import { DefaultOptions } from "@tanstack/react-query";

export const defaultQueryOptions: DefaultOptions = {
  queries: {
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchIntervalInBackground: false,
    gcTime: 1000 * 60 * 30,
    staleTime: 1000 * 60 * 10,
    retry: 1,
  },
};
